<template xmlns="http://www.w3.org/1999/html">

  <div style="height: 100vh;width: 100vw;
  position:relative;
    background: url(/static/images/lbt/bg.png) no-repeat;
    background-attachment:fixed;
    background-size:cover;">


    <img src="/static/images/lbt/logo.png" style="width: 54vw;position: absolute;top:5vh;left: 23vw;z-index:2" />

    <img src="/static/images/lbt/img-product.png" style="width: 100vw;position: absolute;top:0;left:0;z-index:1" />

    <div style="width: 100vw;position: absolute;top:37vh;display: flex;justify-content: center;z-index:2">
      <img src="/static/images/lbt/query-content.png" style="height: 60vh;width: 80vw;" />
    </div>

    <div
      style="width: 100vw;position: absolute;top:37vh;display: flex;height: 60vh;flex-direction: column;align-items: center;justify-content:center;z-index:2">


      <div style="width: 65vw;height: 19vh;border-radius: 6px;border:0;
        box-shadow: 0 0 10px rgba(173, 137, 89, 1);display: flex;flex-direction: column;align-items: center;">
        <div style="width: 100%;height: 14vh;border-radius: 8px;background-color: white;display: flex;">

          <div
            style="height: 100%;width: 100%;display: flex;flex-direction: column;justify-content: center;font-size: 12px;color:rgb(107, 107, 107)">
            <div style="margin-left: 5vw;">产品名称：{{ productName }}</div>
            <div style="margin-left: 5vw;">产品编码：{{ productNo }}</div>
            <div style="margin-left: 5vw;">保&nbsp;&nbsp;质&nbsp;期：{{ bzq }}</div>
            <div style="margin-left: 5vw;">产　　地：{{ place }}</div>
            <div style="margin-left: 5vw;">产品规格：{{ productStandard }}</div>
            
          </div>
          <!-- <div
            style="height: 100%;width: 65%;display: flex;flex-direction: column;justify-content: center;font-size: 12px;color:rgb(107, 107, 107)">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
          </div> -->
        </div>
        <div style="border-top: 1px dashed rgb(173, 137, 89);width: 95%;">
        </div>
        <div 
          style="width: 100%;height: 5vh;border-radius: 8px;background-color: white;display: flex;justify-content: center;align-items: center;">
          <img v-if="!isError" src="/static/images/lbt/zp.png" style="width: 48%;;" />
        </div>
      </div>
      <img src="/static/images/lbt/query-result.png" style="width: 65vw;margin-top: 1.5vh;" />
      <img src="/static/images/lbt/buy.png" style="width: 50vw;" />
      <img src="/static/images/lbt/weapp.png" style="width: 20vw;margin-top: 1.5vh;" />
      <img src="/static/images/lbt/scan-tip.png" style="width: 20vw;margin-top: 1vh;" />
      <img src="/static/images/lbt/rexian.png" style="width: 60vw;margin-top: 1.5vh;" />


    </div>


    <!-- <div v-if="isRepeat"
      style="width: 100vw;height: 100vh;background-color: rgba(24, 24, 24, 0.5);position: absolute;z-index: 4;display: flex;align-items: center;justify-content: center;">
      <div style="width: 67vw;height: 14vh;border-radius: 6px;
       background-color:rgba(24, 24, 24, 0.8);display: flex;
       align-items: center;justify-content: center;
       box-shadow: 30px 0 15px -3px rgba(24, 24, 24, 0.5),-30px 0 15px -3px rgba(24, 24, 24, 0.5);">
        <img src="/static/images/lbt/repeat-scan.png" style="width: 40vw;" />
      </div>
    </div> -->

  </div>


</template>
<style scoped>
input::placeholder {
  font-size: 14px;
}
</style>

<script>
import { getAntiData, getInfoByCode } from '../../api/api'
export default {
  data() {
    return {
      isError:false,
      productNo: "",
      productName: "",
      bzq: "",
      place: "",
      productStandard: "",
    }
  },
  methods: {
    async getResult(eno, code) {
      var res = await getAntiData(code, eno)
      var data = res.data
      if (data == null || data.code == "500") {
        alert("查询异常，请重新输入防伪码进行查询")
      } else {
        if (data.code === "300101") {
          //this.isRepeat = false
          this.isError=false
          this.queryCodeInfo(eno, code)
        } else if (data.code == "300102") {
          this.isError=false
          //this.isRepeat = true
          this.queryCodeInfo(eno, code)
        } else if (data.code == "300106") {
          this.isError=true
          alert("此码不存在，谨防仿冒")
        }
        this.antiMessage = res.data.message
      }
    },
    async queryCodeInfo(eno, code) {
      var res = await getInfoByCode(code)
      console.log('查询的码结果为：', res)
      var data = res.data
      if (data.code == "200" && data.data != null) {
        this.productNo=data.data.productNo
        this.productName=data.data.productName
        this.place=data.data.place
        this.bzq=(data.data.shelfLifeNum!=null && data.data.shelfLifeType!=null)?data.data.shelfLifeNum+data.data.shelfLifeType:''
        this.productStandard=data.data.productStandard
      }
    }
  },
  mounted: function () {
    const params = this.$route.query
    var eno = params.eno
    var antiCode = params.c
    if (eno == null || antiCode == null || antiCode == undefined || eno == undefined) {
      alert("请从正确的入口进入查询")
    } else {
      this.getResult(eno, antiCode)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/LiuBaoTang/Query.vue